module.exports = function getResource(label, vars) {
    const resources = {
        agree: 'J’accepte les',
        sephoraSDU: 'de l’abonnement à la livraison le jour même illimitée de Sephora',
        termsAndConditions: 'Modalités',
        afterTrial:
            `Après mon essai de 30 jours, j’autorise Sephora à facturer ${vars[0]} annuellement à ma méthode de paiement par défaut ou une autre méthode de paiement de mon dossier. Mon abonnement sera automatiquement renouvelé et se poursuivra jusqu’à son annulation. Je reconnais que je peux annuler en tout temps à partir de la page de la livraison le jour même illimitée de Mon compte.`,
        authorize:
            `J’autorise Sephora à facturer ${vars[0]} annuellement à ma méthode de paiement par défaut ou une autre méthode de paiement de mon dossier. Mon abonnement sera automatiquement renouvelé et se poursuivra jusqu’à son annulation. Je reconnais que je peux annuler en tout temps à partir de la page de la livraison le jour même illimitée de Mon compte.`,
        byClicking: 'En cliquant sur le bouton Passer la commande, j’accepte également les',
        termsOfService: 'Conditions de service',
        conditionsOfUse: 'et d’utilisation de Sephora, et j’ai lu la',
        privacyPolicy: 'Politique de confidentialité'
    };

    return resources[label];
};
